import { FC } from 'react';
import { Checkbox } from '~/shared/ui/Checkbox/Checkbox';
import { Control, Controller } from 'react-hook-form';
import { Form } from '~/widgets/Payment/ui/Payment';

interface Props {
  control: Control<Form, any>;
}

export const ControlledCheckbox: FC<Props> = ({ control }) => {
  return (
    <Controller
      name={'autoRenewal'}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Checkbox
          checked={value}
          onCheckedChange={onChange}
          label={'Автопродлять аренду'}
          labelClass={'text-l-b'}
          className={'bg-cDarkGray rounded-[1.2rem] px-2.4 py-2'}
        />
      )}
    />
  );
};
